import React, { useState } from "react";
import pbg from "../img/rectangle-bg.png";
import gal from "../img/gallery.PNG";
import data from "../components/data";
import { AiOutlineDown } from "react-icons/ai";
import Hero from "../components/Hero";

const Home = () => {
  const [dataSai] = useState(data[0]);

  return (
    <div className="flex-row justify-center items-center text-center">
      <Hero />

      <div className="px-5">
        <div className="row justify-center mr-0">
          <div className="flex flex-col items-center w-auto h-full bg-slate-100 text-slate-900">
            <div className="flex flex-col items-center w-full h-full py-10  px-16 max-md:px-1">
              {dataSai.about.map((abt) => {
                return (
                  <div key={abt.title}>
                    <h1 className="text-2xl text-heading font-bold pb-7">
                      {abt.title}
                    </h1>
                    <p className="pb-8">{abt.text}</p>
                    <button className="bg-gradient-to-r from-btn-from to-btn-to text-white font-bold py-2 px-4 rounded">
                      <a href={abt.link}>{abt.btn}</a>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="row  justify-center mr-0">
          <div className="flex flex-col md:flex-row items-center justify-center w-full h-full bg-bg-news">
            <div className="flex flex-col w-full h-full ">
              <h1 className="bg-bg-news-header w-full py-3 mt-0 text-slate-200 ">
                Latest News
              </h1>
              <div className="flex flex-col justify-between items-center h-[350px] ">
                <ul className="py-10">
                  {dataSai.notification.map((n) => {
                    return (
                      <li
                        key={n.id}
                        className="text-gray-800 text-start ml-5 leading-6 pb-3"
                      >
                        <p>{n.text}</p>
                        <p className="text-sm font-thin text-end italic">
                          {n.date}
                        </p>
                      </li>
                    );
                  })}
                </ul>
                <button className="bg-gradient-to-r from-btn-from to-btn-to rounded text-white w-44 h-12 mb-10">
                  <a href="#">Read More</a>
                </button>
              </div>
            </div>
            <div className="flex flex-col items-center w-full h-full bg-bg-appeal">
              <h1 className="bg-bg-appeal-header w-full py-3 text-slate-200 ">
                Latest News
              </h1>
              <div className="flex flex-col justify-between items-center h-[350px] ">
                <ul className="py-10">
                  {dataSai.appeal.map((ap) => {
                    return (
                      <li
                        key={ap.id}
                        className="text-gray-800 text-start ml-5 leading-6 pb-3"
                      >
                        <p>{ap.text}</p>
                        <p className="text-end">
                          <a
                            href={ap.download}
                            className="text-sm font-thin bg-bg-appeal-header px-2 py-1"
                            type="button"
                          >
                            download
                          </a>
                        </p>
                      </li>
                    );
                  })}
                </ul>
                <button className="bg-btn-sec rounded text-white w-44 h-12 mb-10">
                  <a href="#">Read More</a>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className=" row justify-center">
          <div className="flex flex-col items-center w-full h-full bg-white py-8">
            <h1 className=" w-full text-2xl text-heading">Gallery</h1>
            <div className="block items-center justify-center w-full h-full bg-white p-10 mx-auto">
              <img
                src={gal}
                alt=""
                className="block py-2 px-1 w-100 text-center mx-auto "
              />
            </div>
            <a href="">
              <AiOutlineDown className="font-2xl" />
            </a>
          </div>
        </div>

        <div className="row w-full justify-center pb-5 ">
          <div
            className="flex flex-col md:flex-row justify-center h-full bg-transparent px-3 py-5"
            style={{ background: `url(${pbg})` }}
          >
            <div className="flex flex-col items-center justify-center w-full h-full bg-transparent">
              <h1 className="text-2xl text-heading font-bold pb-7">
                Daily Programme
              </h1>

              <div className="flex flex-col items-center w-full h-40 overflow-scroll overflow-x-hidden bg-transparent">
                <ul>
                  {dataSai.d_programme.map((dp) => {
                    return (
                      <div key={dp.id} className="flex  items-center">
                        <li className="text-gray-800 text-start ml-5 leading-6">
                          <p>{dp.time}</p>
                        </li>
                        <li className="text-gray-800 text-start ml-5 leading-6">
                          <p className="border-b-2 border-black after:w-100">
                            {dp.title}
                          </p>
                        </li>
                      </div>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center w-full h-full bg-transparent">
              <h1 className="text-2xl text-heading font-bold pb-7">
                Upcoming Festivals
              </h1>

              <div className="flex flex-col items-center w-full h-40 overflow-scroll overflow-x-hidden bg-transparent"></div>
            </div>
            <div className="flex flex-col items-center justify-center w-full h-full bg-transparent">
              <h1 className="text-2xl text-heading font-bold pb-7">
                Latest Updates
              </h1>

              <div className="flex flex-col items-center w-full h-40 overflow-scroll overflow-x-hidden bg-transparent">
                <ul>
                  {dataSai.d_programme.map((dp) => {
                    return (
                      <div key={dp.id} className="flex  items-center">
                        <li className="text-gray-800 text-start ml-5 leading-6">
                          <p>{dp.time}</p>
                        </li>
                        <li className="text-gray-800 text-start ml-5 leading-6">
                          <p>{dp.title}</p>
                        </li>
                      </div>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
